import React from 'react';
import Table from 'react-bootstrap/Table';

interface DynamicTableProps {
    title: string;
    prix_de_vente: Number;
    surfacturation: string;
}

const DynamicTable: React.FC<DynamicTableProps> = ({ title, prix_de_vente, surfacturation }) => {
    const prix_no_taxe = Number(prix_de_vente) + Number(surfacturation);
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Prix avec taxes</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {prix_no_taxe.toFixed(2)}$+txs = {(1.15 * prix_no_taxe).toFixed(2)}$
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTable;
